import { forwardRef } from 'react';
import { TextField, type TextFieldProps } from './TextField';
import type { TextFieldProps as MuiTextFieldProps } from '@mui/material';

export const TextArea = forwardRef<HTMLDivElement, TextFieldProps & MuiTextFieldProps>(({ ...restProps }, ref) => (
  <TextField
    maxRows={4}
    minRows={1}
    ref={ref}
    multiline
    variant="outlined"
    {...restProps}
  />
));
